import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Radio, Checkbox, message, } from 'antd';
import { useNavigate } from 'react-router-dom';
import { courseCategoryList, infoCourse, editCourse } from '../../../http/modules/organization'
import Oss from '../../../components/ossUpload/oss'
import './index.scss'

export default function Amend(props) {

    const { courseUUID, onDone } = props

    const [form] = Form.useForm();

    const navigate = useNavigate();

    //全部课程类别
    const [categoryList, setCategoryList] = useState()
    // 课程详情
    const [course, setCourse] = useState()
    // 课程名称
    const [title, setTitle] = useState()
    // 课程类别
    const [kclb, setKclb] = useState()
    // 是否可以提交
    const [disabled, setDisabled] = useState(true)
    // 报名表Url 
    const [formUrl, setFormUrl] = useState()
    // 报名表文件名称 
    const [formName, setFormName] = useState()
    // 附件
    const [fuJian, setFuJian] = useState([])
    // 报名报url
    const [baoMingUrl, setBaoMingUrl] = useState()
    // 报名name
    const [baoMingName, setBaoMingName] = useState()
    // 附件
    const [fujianData, setfujianData] = useState()

    // 二级标签（后端新增字段 subCates）
    // 用 null 区分“还没加载详情”，避免用户清空时又 fallback 到旧值
    const [subCates, setSubCates] = useState(null)

    // 当前一级类别下的二级标签列表
    const [currentSubList, setCurrentSubList] = useState([])

    const [oss, setoss] = useState()


    //课程类别
    const onCourseCategoryList = async () => {
        const res = await courseCategoryList({})
        setCategoryList(res.data?.list)
    }

    //课程详情
    const onInfoCourse = async () => {
        const res = await infoCourse({
            courseUUID: courseUUID
        })
        if (res.code == 0) {
            setCourse(res.data)
            setTitle(res.data.title)
            setKclb(res.data.category)
            // Keep antd Form store in sync so Form.Item(name=...) doesn't override UI values.
            form.setFieldsValue({
                title: res.data.title,
                category: res.data.category,
                goal: res.data.goal,
                apply: res.data.apply,
                feature: res.data.feature,
                assist: res.data.assist,
            })
            setBaoMingUrl(res.data.formUrl)
            setBaoMingName(res.data.formName)
            setFuJian(res.data.attachmentList)
            setfujianData(res.data.attachmentList)

            // 详情回显：二级标签字段以 subCates 为准（兼容大小写/旧字段）
            setSubCates(res.data.subCates || res.data.subcates || res.data.subCateList || [])
        }
    }

    // 提交
    const onFinish = async () => {
        const extra = form.getFieldsValue(["goal", "apply", "feature", "assist"])
        const finalTitle = title ?? course?.title
        const finalCategory = kclb ?? course?.category
        const finalSubCates = Array.isArray(subCates) ? subCates : []

        // 仅当该一级类别存在二级标签时才校验
        if (currentSubList?.length) {
            if (!finalSubCates || finalSubCates.length < 1 || finalSubCates.length > 3) {
                message.error('请选择 1-3 个二级课程类别')
                return
            }
        }

        const res = await editCourse({
            "courseUUID": courseUUID,
            "title": finalTitle,
            "category": finalCategory,
            // 后端字段：subCates（二级标签）
            "subCates": currentSubList?.length ? finalSubCates : [],
            "formUrl": formUrl ?? course?.formUrl,
            "formName": formName ?? course?.formName,
            // New text fields (keep types aligned with infoCourse)
            "goal": extra.goal ?? course?.goal ?? '',
            "apply": extra.apply ?? course?.apply ?? '',
            "feature": extra.feature ?? course?.feature ?? '',
            "assist": extra.assist ?? course?.assist ?? '',
            attachmentList: fuJian,
        })
        if (res.code == 0) {
            setoss()
            message.success('修改成功')
            form.resetFields();
            if (typeof onDone === 'function') {
                onDone()
            } else {
                navigate('/organization/applyList')
            }
        }
    };
    // 附件数据处理
    const onFuJian = (name, url) => {
        setFuJian(fuJian => [...fuJian, {
            "name": name,
            "url": url,
            "operate": 'add'
        }]);
        setfujianData(fujianData => [...fujianData, {
            "name": name,
            "url": url,
            "operate": 'add'
        }])
    }

    // 删除
    const remove = (id) => {
        let a = fuJian?.map((item) => {
            if (item.uuid == id) {
                item.operate = 'delete'
            }
            return item
        })
        setFuJian(a)

        let b = [...fujianData]

        b?.splice(b.findIndex(item => item.uuid == id), 1)

        // fujianData.forEach((item, index) => {
        //     if (item.uuid == id) {
        //         fujianData.splice(index, 1);
        //     }
        // });
        setfujianData(b)
    }

    useEffect(() => {
        onCourseCategoryList()
        onInfoCourse()
    }, [])

    useEffect(() => {
        const current = categoryList?.find(i => i.name === kclb)
        setCurrentSubList(current?.subCateList || [])
    }, [categoryList, kclb])

    const effectiveSubCates = Array.isArray(subCates) ? subCates : []

    return (
        <div className='applyAdd'>
            <header>
                <p></p>
                修改报名
            </header>
            <Form
                form={form}
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 18,
                }}
                layout="horizontal"
            >

                <Form.Item
                    label="授课人"
                >
                    {course ? <Input defaultValue={course?.playerName} disabled={true} /> : ''}
                </Form.Item>

                <Form.Item label="课程名称" name='title' rules={[
                    {
                        required: true,
                        message: '请填写课程名称!'
                    },]}>
                    {course ? <Input onChange={(e) => setTitle(e.target.value)} defaultValue={course?.title} /> : ''}
                </Form.Item>               

                <Form.Item label="课程类别" name='category' rules={[
                    {
                        required: true,
                        message: '请选择课程类别!'
                    },]}>
                    {course ? <Radio.Group
                        value={kclb ?? course?.category}
                        onChange={((e) => {
                            setKclb(e.target.value)
                            // 切换一级类别后，二级标签需要重新选择
                            setSubCates([])
                        })}
                    >
                        {categoryList?.map((item) => {
                            return <Radio style={{ fontSize: '18px' }} key={item.name} value={item.name}> {item.name} </Radio>
                        })}
                    </Radio.Group> : ''}
                </Form.Item>

                <Form.Item label="二级课程类别" required={!!currentSubList?.length}>
                    {currentSubList?.length ? (
                        <Checkbox.Group
                            value={effectiveSubCates}
                            onChange={setSubCates}
                            style={{ display: 'flex', flexWrap: 'wrap', gap: 16, fontSize: 16 }}
                        >
                            {currentSubList?.map(sub => (
                                <Checkbox
                                    key={sub}
                                    value={sub}
                                    disabled={effectiveSubCates.length >= 3 && !effectiveSubCates.includes(sub)}
                                    style={{ fontSize: 16 }}
                                >
                                    {sub}
                                </Checkbox>
                            ))}
                        </Checkbox.Group>
                    ) : (
                        <span style={{ color: '#999', fontSize: 16 }}>该类别无二级课程类别</span>
                    )}
                </Form.Item>

                <Form.Item label="课程目标" name="goal" rules={[{ max: 500, message: '最多500字' }]}>
                    <Input.TextArea rows={4} placeholder="请简要说明通过学习课程，预期掌握的理论、知识点，以及可提升的实操应用、能力素养等。" maxLength={500} showCount />
                </Form.Item>

                <Form.Item label="课程建设及应用情况" name="apply" rules={[{ max: 500, message: '最多500字' }]}>
                    <Input.TextArea rows={4} placeholder="请简要说明课程主要内容、相关教材、教学方法、以及课程在实际应用、效果反馈等方面的应用情况。" maxLength={500} showCount />
                </Form.Item>

                <Form.Item label="课程特色与创新实践" name="feature" rules={[{ max: 500, message: '最多500字' }]}>
                    <Input.TextArea rows={4} placeholder="请简要说明课程在教学内容、教学模式等方面的亮点特色，以及在实操、成果转化等方面创新实践举措。" maxLength={500} showCount />
                </Form.Item>

                <Form.Item label="教辅工具" name="assist" rules={[{ max: 500, message: '最多500字' }]}>
                    <Input.TextArea rows={4} placeholder="请说明课程配套使用的教学辅助工具，如课件PPT、案例素材、练习题、视频音频、工具包等，简要列明类型及用途，如无可填“无”。" maxLength={500} showCount />
                </Form.Item>

                <Form.Item label="授课类型" name='typ'>
                    {
                        course ? <Input defaultValue={course?.typ} disabled={true} /> : ''
                    }
                </Form.Item>

                <Form.Item wrapperCol={{
                    offset: 0,
                    span: 14,
                }} label="上传视频" valuePropName="fileList">
                    <>
                        {course ? <div className='video'>
                            <video src={course?.mainCourseUrl?.split("?")[0]} controls width={430} height={200}></video>
                            <span title={course.mainCourseName}> 课程名称：{course.mainCourseName}</span>
                        </div> : ''}
                        {course?.typ == '标准课程' ? <div className='video'>
                            <video src={course?.subCourseUrl?.split("?")[0]} controls width={430} height={200}></video>
                            <span title={course.subCourseName}> 课程名称：{course.subCourseName}</span>
                        </div> : ''}
                    </>
                </Form.Item>


                <Form.Item label="上传附件" valuePropName="fileList">
                    <>
                        <div className='fujian'>
                            {baoMingName ? <p>
                                <span title={baoMingName} style={{ width: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>报名表：{baoMingName}</span><span style={{ color: 'red' }}><a href={baoMingUrl?.split("?")[0]}>申报表下载</a><span style={{ cursor: 'pointer' }} onClick={() => { setBaoMingName() }}>X</span></span>
                            </p> : ''}
                            <Oss oss={oss} url={setFormUrl} province={course?.pinyin} kclb={course?.iniCategory} title={course?.iniTitle} video={'baoming'} Name={setFormName} buttonName={baoMingName ? '请先删除' : '上传申报表'} />
                        </div>

                        <div className='fujian'>
                            {fujianData?.map((item) => {
                                return <p key={item.uuid}>
                                    <span title={item.name} style={{ width: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>名称:{item.name}</span> <span style={{ color: 'red' }}> <a href={item.url?.split("?")[0]}>附件下载</a> <span
                                        onClick={() => remove(item.uuid)} style={{ cursor: 'pointer' }}>X</span></span>
                                </p>
                            })}
                            <Oss fuJian={fujianData} oss={oss} onFuJian={onFuJian} province={course?.pinyin} kclb={course?.iniCategory} title={course?.iniTitle} buttonName='教辅工具' />
                        </div>
                    </>
                </Form.Item>

                <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 4, span: 22 }}>
                    <Checkbox style={{ fontSize: '16px' }} onChange={(value) => setDisabled(!value.target.checked)}>本人承诺该课程可免费、公开向社会发布使用，视频课程不侵犯第三方知识产权，如有任何知识产权纠纷，由报送人承担全部责任。</Checkbox>
                </Form.Item>

                {/* <Form.Item
                    wrapperCol={{
                        offset: 8,
                        span: 16,
                    }}
                >
                    <Button style={{ marginBottom: '20px' }} type="primary" htmlType="submit" disabled={disabled} onClick={onFinish}>
                        提交
                    </Button>
                </Form.Item> */}


                <Form.Item
                    wrapperCol={{
                        offset: 12,
                        span: 12,
                    }}>
                    <Button type="primary" htmlType="submit" disabled={disabled} onClick={onFinish} className='queDing' title={disabled ? '请先同意承诺' : ''}>
                        确定
                    </Button>
                </Form.Item>

            </Form>
        </div>
    )
}
